import { Pipe, PipeTransform } from '@angular/core';
import { GboxAnswer } from '@/tms/reports/_models/reports.model';

@Pipe({ name: 'questionLabel', standalone: true })
export class QuestionLabelPipe implements PipeTransform {
	transform(answer: GboxAnswer): string {
		const text = answer.questionText?.trim();
		if (text) {
			return text;
		}
		if (/^scan-\d+$/.test((answer.answer ?? '').trim())) {
			return 'Załącznik / skan';
		}
		return answer.idQuestion !== null ? `Pytanie techniczne #${answer.idQuestion}` : 'Pytanie techniczne';
	}
}
